import React from "react";
import PropTypes from "prop-types";
import { useFormContext, useController } from "react-hook-form";
import VStack from "shared/components/layout/stack/VStack";
import Checkbox from "shared/components/inputs/checkbox/Checkbox";
import Radio from "shared/components/inputs/radio/Radio";
import FormInputWrapper from "shared/components/inputs/form/FormInputWrapper";
import { getFeedbackProps } from "./utils";
import { FormInputWrapperText, InputLabel, Wrapper } from "./Options.styles";

const Options = ({
    name,
    labelVariant,
    label,
    description,
    defaultSelection,
    options = [],
    multiselect = true,
    validations = {},
    onValueSelected = () => void 0,
    disabled,
}) => {
    const {
        formState: { errors },
    } = useFormContext();
    const { field } = useController({
        name,
        rules: validations,
        defaultValue: defaultSelection ?? "",
    });

    const { value, onChange, onBlur } = field;
    const valueArray = value.length ? value.split(",") : [];

    const Element = multiselect ? Checkbox : Radio;

    const fieldErrors = errors[name];
    const feedbackProps = getFeedbackProps(fieldErrors);

    return (
        <Wrapper>
            <VStack>
                {(label || description) && (
                    <div>
                        {label && (
                            <InputLabel labelVariant={labelVariant}>
                                {label}
                            </InputLabel>
                        )}
                        {description && (
                            <FormInputWrapperText
                                color="Gray_2"
                                variant="Descriptive_1_1"
                            >
                                {description}
                            </FormInputWrapperText>
                        )}
                    </div>
                )}
                <VStack spacing="Zero_75" align="start">
                    {options.map(({ value, label }) => (
                        <Element
                            disabled={disabled}
                            label={label}
                            value={value}
                            key={value}
                            checked={valueArray.includes(value)}
                            onBlur={onBlur}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                const checkedValues = multiselect ? [...valueArray, value] : [value];
                                const newValueArray = checked
                                    ? checkedValues
                                    : valueArray.filter(
                                          (valueEntry) => valueEntry !== value
                                      );

                                onChange(newValueArray.join(","));
                                onValueSelected(newValueArray.join(","));
                            }}
                        />
                    ))}
                </VStack>
                {feedbackProps.feedbackMessage && (
                    <FormInputWrapper {...feedbackProps} />
                )}
            </VStack>
        </Wrapper>
    );
};

Options.propTypes = {
    name: PropTypes.string.isRequired,
    labelVariant: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    defaultSelection: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
    multiselect: PropTypes.bool,
    validations: PropTypes.object,
    onValueSelected: PropTypes.func,
    disabled: PropTypes.bool,
};

export default Options;
